import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageDataModel } from "@AppCore/constants/local-storage-data-model";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private router: Router, private globalUtility: GlobalUtilityService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const key = this.globalUtility.getDataFromLocalStorage(LocalStorageDataModel.AUTH_KEY);
    if (key) {
			return true;
		} else {
			this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
			return false;
		}

  }
  
}